import { render, staticRenderFns } from "./EditCourseCategoryPopup.vue?vue&type=template&id=a2324e8e"
import script from "./EditCourseCategoryPopup.vue?vue&type=script&lang=js"
export * from "./EditCourseCategoryPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports